import React, { Component } from 'react';
import {
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CSpinner,
    CCol,
    CRow,
    CFormInput,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CFormSelect,
    CFormSwitch,
} from '@coreui/react'
import {
    cilBan,
    cilCheck,
    cilLink,
    cilPencil,
    cilPlus,
    cilSave,
    cilSearch,
} from '@coreui/icons'
import TableActions from '../../components/TableActions'
import ServerConnector from 'src/ServerConnector'
import AppButton from 'src/components/AppButton'
import PageHeader from 'src/components/PageHeader'
import { capitalizeText, replaceEmpty } from 'src/util/StringUtil';
import AsyncSelect from 'react-select/async';

class ManageChatGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spinner: false,
            table_list: [],
            search_str: "",
            popupSelectedUserSeq: -1,
            popupSelectedIsAdmin: false,
            popupUserList: [],
            addMemberPopup: {
                data: [],
                visible: false,
                selected_group_seq: -1,
                selected_group_name: "",
                removeLoadingSeq: -1,
                addButtonLoading: false
            },
            userLoaded: false,
        };
        this.timeout = 0;
    }

    componentDidMount() {
        this.loaddata()
    }

    loaddata() {
        this.setState({
            spinner: true
        });
        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_CHAT_GROUPS"
        }

        if (this.state.search_str.length != 0) {
            dataMap["search_str"] = this.state.search_str;
        }

        connector.postData(dataMap, (data) => { // success
            this.setState({
                spinner: false,
                table_list: data.data
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false,
                table_list: []
            });
        });
    }

    confirmStatusChange(group_seq, action) {

        var msg = "Do you want to deactivate this chat group?";
        if (action == "REACTIVATION") {
            msg = "Do you want to activate this chat group?";
        }

        this.props.showConfirmation(
            "Confirmation",
            msg,
            "Yes",
            "No",
            null,
            () => { this.statusChange(group_seq, action) }
        )
    }

    statusChange(group_seq, action) {

        this.props.showPageSpinner(true);

        var newStatus = "INACTIVE";
        if (action == "REACTIVATION") {
            newStatus = "ACTIVE";
        }

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "SET_CHAT_GROUP_STATUS",
            "group_seq": group_seq,
            "status": newStatus
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.loaddata()
            });
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    updateSearchInput(event) {

        this.setState({
            search_str: event.target.value
        });
    }
    getRandomNumber() {

        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        return rand;
    }
    getGroupMembersPopup(group_seq, group_name) {
        this.props.showPageSpinner(true);
        let addMemberPopup = this.state.addMemberPopup;
        addMemberPopup["selected_group_seq"] = group_seq;
        addMemberPopup["selected_group_name"] = group_name;
        addMemberPopup["visible"] = true;

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_GROUP_MEMBERS",
            "group_seq": group_seq
        }
        connector.postData(dataMap, (data) => { // success
            this.props.showPageSpinner(false);
            addMemberPopup["data"] = data.data;
            this.setState({
                addMemberPopup: addMemberPopup
            }, () => {
                // this.loadUserListForPopup();
            });

        }, (err_id, msg, data) => { // failure

            this.props.showPageSpinner(false);

            if (err_id == "UE005") {

                addMemberPopup["data"] = [];

                this.setState({
                    addMemberPopup: addMemberPopup
                }, () => {
                    // this.loadUserListForPopup();
                });
            }
            else {

                this.props.showAlert("Error", msg, "Ok", null, null);
            }
        });
    }
    closeAddMemberPopup() {
        let addMemberPopup = this.state.addMemberPopup;
        addMemberPopup["visible"] = false;
        this.setState({
            addMemberPopup: addMemberPopup
        });
    }

    onPopupUserSelected(event) {
        if (event != null) {
            this.setState({
                popupSelectedUserSeq: event.value
            });
        }
        else {
            this.setState({
                popupSelectedUserSeq: ""
            });
        }

    }
    loadUserListForPopup(searchStr, callBack) {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_ACTIVE_USERS"
        }
        if (searchStr != undefined && searchStr != null && searchStr.length != 0) {
            dataMap.search_str = searchStr;
        }
        connector.postData(dataMap, (data) => { // success  
            let list = [];
            data.data.map(obj => {
                let role = capitalizeText(obj.role);
                list.push({ value: obj.user_seq, label: obj.name + " (" + role + ")" });
            });
            callBack(list)
            this.setState({
                popupUserList: list,
                userLoaded: true,
            });
        }, (err_cd, msg, data) => { // failure
            callBack([]);
            this.setState({
                popupUserList: [],
                disableSelect: false,
                userLoaded: true,
            });
        })
    }
    addMemberToGroup(isAdmin) {
        if (this.state.popupSelectedUserSeq <= 0) {
            this.props.showAlert("Alert", "Please select user", "Ok", null, null);
        }
        else {
            let addMemberPopup = this.state.addMemberPopup;
            addMemberPopup["addButtonLoading"] = true;
            this.setState({
                addMemberPopup: addMemberPopup
            });
            let connector = new ServerConnector();
            let dataMap = {
                "_action_code": "ADD_GROUP_MEMBER",
                user_seq: this.state.popupSelectedUserSeq,
                group_seq: this.state.addMemberPopup.selected_group_seq,
                is_admin: isAdmin ? "YES" : "NO"
            }
            connector.postData(dataMap, (data) => { // success

                addMemberPopup = this.state.addMemberPopup;
                addMemberPopup["addButtonLoading"] = false;
                this.setState({
                    addMemberPopup: addMemberPopup,
                    popupSelectedUserSeq: -1
                }, () => {

                    this.getGroupMembersPopup(
                        this.state.addMemberPopup.selected_group_seq,
                        this.state.addMemberPopup.selected_group_name
                    );
                });
            }, (err_cd, msg, data) => { // failure

                addMemberPopup = this.state.addMemberPopup;
                addMemberPopup["addButtonLoading"] = false;
                this.setState({
                    addMemberPopup: addMemberPopup
                });

                this.props.showAlert("Error", msg, "Ok", null, null);
            });
        }
    }
    removeMemberFromGroup(userSeq) {

        let addMemberPopup = this.state.addMemberPopup;
        addMemberPopup["removeLoadingSeq"] = userSeq;
        this.setState({
            addMemberPopup: addMemberPopup
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "REMOVE_GROUP_MEMBER",
            user_seq: userSeq,
            group_seq: this.state.addMemberPopup.selected_group_seq,

        }
        connector.postData(dataMap, (data) => { // success

            addMemberPopup = this.state.addMemberPopup;
            addMemberPopup["removeLoadingSeq"] = -1;
            this.setState({
                addMemberPopup: addMemberPopup
            }, () => {

                this.getGroupMembersPopup(
                    this.state.addMemberPopup.selected_group_seq,
                    this.state.addMemberPopup.selected_group_name
                );
            });

        }, (err_cd, msg, data) => { // failure

            addMemberPopup = this.state.addMemberPopup;
            addMemberPopup["removeLoadingSeq"] = -1;
            this.setState({
                addMemberPopup: addMemberPopup
            });
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }
    loadOptions(inputValue, callback) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            if (inputValue.length >= 3) {
                if (this.state.userLoaded) {
                    if (inputValue.length == 3) {
                        this.loadUserListForPopup(inputValue, callback);
                    }
                    else {
                        let list = this.filterOnSearch(inputValue)
                        callback(list)
                    }
                }
                else {
                    this.loadUserListForPopup(inputValue, callback);
                }
            }
            else {
                this.setState({
                    userLoaded: false,
                })
                callback([]);
            }
        }, 300);


    }
    filterOnSearch = (inputValue) => {
        return this.state.popupUserList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };
    onPopupIsAdminChange(event) {
        this.setState({
            popupSelectedIsAdmin: event.target.checked,
        });
    }

    render() {

        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Add Chat Group"
                        icon={cilPlus}
                        isLoading={false}
                        onClick={() => this.props.navigate("add_chat_group", { group_seq: -999 })} />
                </PageHeader>
                <CRow>
                    <CCol md="3">
                        <CFormInput
                            type="text"
                            placeholder="Search"
                            onChange={(event) => { this.updateSearchInput(event) }}
                            value={this.state.search_str} />
                    </CCol>
                    <CCol md="9">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loaddata(); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{ width: '40%' }} scope="col">Group Name</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '20%' }} scope="col">Created By</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '20%' }} scope="col">Crated On</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Status</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Actions</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.table_list.map((object, index) => {
                                let menuList = [
                                    {
                                        name: "Edit",
                                        icon: cilPencil,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.props.navigate("add_chat_group", { group_seq: object.group_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "View",
                                        icon: cilSearch,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.props.navigate("view_chat_group", { group_seq: object.group_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "Add Members",
                                        icon: cilLink,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.getGroupMembersPopup(object.group_seq, object.group_name) },
                                        data: null
                                    },
                                    {
                                        name: "Deactivate",
                                        icon: cilBan,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.group_seq, "DEACTIVATION") },
                                        data: null
                                    },
                                    {
                                        name: "Activate",
                                        icon: cilCheck,
                                        isLoading: false,
                                        visible: object.status != "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.group_seq, "REACTIVATION") },
                                        data: null
                                    }
                                ];

                                return (
                                    <CTableRow key={String(object.group_seq)}>
                                        <CTableDataCell scope="row">{replaceEmpty(object.group_name)}</CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.name)}</CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.created_on)}</CTableDataCell>
                                        <CTableDataCell>
                                            <CBadge color={object.status == "ACTIVE" ? "primary" : "danger"} shape="rounded-pill" size="sm">{object.status}</CBadge>
                                        </CTableDataCell>
                                        <CTableDataCell>
                                            <TableActions
                                                key={String(object.group_seq) + object.status}
                                                actions={menuList}
                                                minCount="1" />
                                        </CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                        {
                            this.state.table_list.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={5} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>
                <CModal
                    visible={this.state.addMemberPopup.visible}
                    size='xl'
                    onClose={() => { this.closeAddMemberPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Add Member To {this.state.addMemberPopup.selected_group_name}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="7">
                                <AsyncSelect
                                    loadOptions={this.loadOptions.bind(this)}
                                    placeholder="Please type atleast 3 character to search user..."
                                    onChange={this.onPopupUserSelected.bind(this)}
                                    isClearable={true}
                                    value={this.state.popupUserList.filter(({ value }) => value === this.state.popupSelectedUserSeq)} />
                                {/* <CFormSelect size="sm" value={this.state.popupSelectedUserSeq}
                                    onChange={(event) => { this.onPopupUserSelected(event) }}>
                                    <option value="-1">Select User</option>
                                    {
                                        this.state.popupUserList.map((object, index) => {
                                            return (
                                                <option key={String(object.user_seq)} value={object.user_seq}>{`${object.name}`}</option>
                                            )
                                        })
                                    }
                                </CFormSelect> */}
                            </CCol>
                            <CCol md="5">
                                <AppButton
                                    size="sm"
                                    className="me-2"
                                    name="Add as User"
                                    color="primary"
                                    icon={cilPlus}
                                    isLoading={this.state.addMemberPopup.addButtonLoading}
                                    isBoldFont={false}
                                    onClick={() => this.addMemberToGroup(false)} />
                                <AppButton
                                    size="sm"
                                    name="Add as Admin"
                                    color="primary"
                                    icon={cilPlus}
                                    isLoading={this.state.addMemberPopup.addButtonLoading}
                                    isBoldFont={false}
                                    onClick={() => this.addMemberToGroup(true)} />
                            </CCol>
                        </CRow>
                        <CTable className="linkSubjectTable">
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">Member Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Role</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Admin</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Actions</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    this.state.addMemberPopup.data.map((object, index) => {
                                        let menuList = [
                                            {
                                                name: "Remove",
                                                icon: cilBan,
                                                isLoading: this.state.addMemberPopup.removeLoadingSeq == object.user_seq,
                                                visible: true,
                                                onClick: () => { this.removeMemberFromGroup(object.user_seq) },
                                                data: null
                                            },
                                        ];

                                        return (
                                            <CTableRow key={String(object.user_seq)}>
                                                <CTableDataCell>{object.name}</CTableDataCell>
                                                <CTableDataCell>{capitalizeText(object.role)}</CTableDataCell>
                                                <CTableDataCell>{object.is_admin}</CTableDataCell>
                                                <CTableDataCell>
                                                    <TableActions
                                                        key={String(object.user_seq) + String(this.getRandomNumber())}
                                                        actions={menuList}
                                                        minCount="1" />
                                                </CTableDataCell>
                                            </CTableRow>
                                        )
                                    })
                                }
                                {
                                    this.state.addMemberPopup.data.length == 0 ?
                                        <CTableRow>
                                            <CTableDataCell colSpan={2} className="alignCenter">No Data Available</CTableDataCell>
                                        </CTableRow>
                                        :
                                        null
                                }
                            </CTableBody>
                        </CTable>
                    </CModalBody>
                </CModal>
            </>
        );
    }
}

export default ManageChatGroup;